module.exports = __webpack_public_path__ + "static/media/percentage-red.fd32d27a.svg";